"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.HiddenSpan = styled_components_1.default.span `
  ${(props) => props.hidden ? `visibility: hidden;` : ``};
`;
exports.HiddenSpan.displayName = "HiddenSpan";
